import { HttpClient } from "@angular/common/http";
import { Injectable, signal } from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class SearchService {
    searchData = signal<{}>({})
    constructor(private http: HttpClient) { }
    

    setSearchData(data: {}) {
        this.searchData.set(data)
    }

    getSearchData() {
        return this.searchData();
    }



}